import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { PaymentIntentDto } from "../../../models/payment/dto/payment-intent.dto";

export const PAYMENT_INTENTS_FOR_COACHING_SESSION_QUERY_KEY = (sessionId: string) => ['payment-intents-for-coaching-session', sessionId];

export const useGetPaymentIntentsForCoachingSession = (sessionId: string) => {
    const apiClient = useApiClient();

    return useQuery<PaymentIntentDto[]>({
        queryKey: PAYMENT_INTENTS_FOR_COACHING_SESSION_QUERY_KEY(sessionId),
        queryFn: async () => {
            return apiClient.fetchApi<PaymentIntentDto[], {}>({
                method: 'GET',
                endpoint: `payments/coaching-session/${sessionId}/payment-intents`
            });
        },
        enabled: !!sessionId,
    });
};
